import { Component, Input } from '@angular/core';

/**
 * renderer des widgets des vues
 */
@Component({
  selector: 'widget-renderer',
  templateUrl: './widget.renderer.html',
})
export class WidgetRenderer {
  /** icon du titre du widget */
  @Input() titleIcon: string;
  /** titre du widget */
  @Input() title: string;

  /** titre du widget */
  @Input() description: string;
}
